import { Card, CardBody, EmptyState, Text } from '~/design_system'
import { Msg } from '~/common/localizationUtils'

const ServerError = () => (
  <Card>
    <CardBody>
      <EmptyState>
        <EmptyState.UnexpectedError />
        <Text>
          <Msg id="common.ui.error_processing_request_try_again" />
        </Text>
      </EmptyState>
    </CardBody>
  </Card>
)

export default ServerError
